// Main
import "./main";

// Global
import "./globals";
import "./modules/bootstrap";
import "./modules/theme";
import "./modules/feather";
import "./modules/dayjs";
import "./modules/sidebar";
import "./modules/geolocator";
import "./modules/croppie";

// Charts
import "./modules/chartjs";

// Forms
import "./modules/select2"; // requires jQuery
import "./modules/validation"; // requires jQuery
import "./modules/wizard"; // requires jQuery
import "./modules/bs-selector";
import "./modules/bootstrap-select";
import "./modules/timeago";
import "./modules/browser-update";

// Tables
import "./modules/datatables"; // requires jQuery

// Vue
import { createApp } from 'vue';
window.createApp = createApp;

import { useForm } from 'laravel-precognition-vue';
import { detectIncognito } from "detectincognitojs";

window.useForm = useForm;
window.detectIncognito = detectIncognito;